/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown>, sessions: NonNullable<unknown> }} Wrapped_Share_CoverInputs */

const en_us2_wrapped_share_cover = /** @type {(inputs: Wrapped_Share_CoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Closed the week of ${i?.range} with ${i?.sessions} on My Pocket Gym.`)
};

const pt_br2_wrapped_share_cover = /** @type {(inputs: Wrapped_Share_CoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fechei a semana de ${i?.range} com ${i?.sessions} no My Pocket Gym.`)
};

const es_419_wrapped_share_cover = /** @type {(inputs: Wrapped_Share_CoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cerré la semana del ${i?.range} con ${i?.sessions} en My Pocket Gym.`)
};

const pt_pt2_wrapped_share_cover = /** @type {(inputs: Wrapped_Share_CoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fechei a semana de ${i?.range} com ${i?.sessions} no My Pocket Gym.`)
};

const fr_fr2_wrapped_share_cover = /** @type {(inputs: Wrapped_Share_CoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`J'ai bouclé la semaine du ${i?.range} avec ${i?.sessions} sur My Pocket Gym.`)
};

const de_de2_wrapped_share_cover = /** @type {(inputs: Wrapped_Share_CoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Woche vom ${i?.range} mit ${i?.sessions} bei My Pocket Gym abgeschlossen.`)
};

const it_it2_wrapped_share_cover = /** @type {(inputs: Wrapped_Share_CoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ho chiuso la settimana del ${i?.range} con ${i?.sessions} su My Pocket Gym.`)
};

/**
* | output |
* | --- |
* | "Closed the week of {range} with {sessions} on My Pocket Gym." |
*
* @param {Wrapped_Share_CoverInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_share_cover = /** @type {((inputs: Wrapped_Share_CoverInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Share_CoverInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_share_cover(inputs)
	if (locale === "es-419") return es_419_wrapped_share_cover(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_share_cover(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_share_cover(inputs)
	if (locale === "de-DE") return de_de2_wrapped_share_cover(inputs)
	if (locale === "it-IT") return it_it2_wrapped_share_cover(inputs)
	return en_us2_wrapped_share_cover(inputs)
});
export { wrapped_share_cover as "wrapped.share_cover" }